/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-02 15:51:26
 */

export default {
    path: 'individual',
    component: () => import(/* webpackChunkName: "individual-list" */ '@/pages/individual/List'),
    meta: {title:'集群注册',cate:'操作中心'},
    children: [
        {
          path: ':individual_id/view',
          component: () => import(/* webpackChunkName: "individual-view" */ '@/pages/individual/CreateEdit'),
          meta: {title:'查看集群注册'},
        }
      ]
}